var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 200,
    viewBox: "0 0 201 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.9502 175C54.5276 175 20.9502 141.423 20.9502 100C20.9502 58.5774 54.5276 25 95.9502 25C137.373 25 170.95 58.5774 170.95 100C170.95 141.423 137.373 175 95.9502 175Z",
    fill: "url(#paint0_linear_26801_1590)",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.42 104.452V119.445L141.414 104.452H126.42Z",
    fill: "url(#paint1_linear_26801_1590)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.711 125.28C124.49 125.28 124.268 125.237 124.056 125.149C123.418 124.885 123 124.262 123 123.571V102.743C123 101.8 123.767 101.035 124.709 101.035H145.537C146.227 101.035 146.85 101.452 147.115 102.09C147.381 102.728 147.234 103.464 146.744 103.952L125.916 124.78C125.592 125.107 125.154 125.28 124.711 125.28Z",
    fill: "url(#paint2_linear_26801_1590)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.1945 134.97H63.6774C62.7348 134.97 61.969 134.204 61.969 133.261V102.743C61.969 101.8 62.7348 101.035 63.6774 101.035H94.1959C95.1389 101.035 95.9044 101.8 95.9044 102.743V133.261C95.903 134.205 95.1389 134.97 94.1945 134.97Z",
    fill: "url(#paint3_linear_26801_1590)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8679 70.5179H61.9676V43.4169H34.8679V70.5179Z",
    fill: "url(#paint4_linear_26801_1590)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.385 70.5179H92.486V43.4169H65.385V70.5179Z",
    fill: "url(#paint5_linear_26801_1590)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.385 101.035H92.486V73.9347H65.385V101.035Z",
    fill: "url(#paint6_linear_26801_1590)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.1945 104.452H63.6774C62.7348 104.452 61.969 103.686 61.969 102.743V72.2265C61.969 71.2831 62.7348 70.5177 63.6774 70.5177H94.1959C95.1389 70.5177 95.9044 71.2831 95.9044 72.2265V102.743C95.903 103.686 95.1389 104.452 94.1945 104.452Z",
    fill: "url(#paint7_linear_26801_1590)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M87.445 88.3181C87.445 90.1395 87.0862 91.6891 86.3686 92.9668C85.6566 94.2446 84.6847 95.2205 83.4529 95.8947C82.2268 96.5635 80.848 96.8979 79.3167 96.8979C77.7742 96.8979 76.3898 96.5608 75.1636 95.8866C73.9375 95.2124 72.9684 94.2364 72.2564 92.9587C71.5445 91.6809 71.1885 90.1341 71.1885 88.3181C71.1885 86.4966 71.5445 84.947 72.2564 83.6693C72.9684 82.3916 73.9375 81.4183 75.1636 80.7495C76.3898 80.0753 77.7742 79.7382 79.3167 79.7382C80.848 79.7382 82.2268 80.0753 83.4529 80.7495C84.6847 81.4183 85.6566 82.3916 86.3686 83.6693C87.0862 84.947 87.445 86.4966 87.445 88.3181ZM83.7241 88.3181C83.7241 87.1382 83.5405 86.1432 83.1732 85.3331C82.8116 84.5229 82.3002 83.9085 81.6391 83.4899C80.978 83.0712 80.2039 82.8619 79.3167 82.8619C78.4296 82.8619 77.6555 83.0712 76.9944 83.4899C76.3333 83.9085 75.8191 84.5229 75.4518 85.3331C75.0902 86.1432 74.9093 87.1382 74.9093 88.3181C74.9093 89.4979 75.0902 90.4929 75.4518 91.3031C75.8191 92.1132 76.3333 92.7276 76.9944 93.1463C77.6555 93.5649 78.4296 93.7742 79.3167 93.7742C80.2039 93.7742 80.978 93.5649 81.6391 93.1463C82.3002 92.7276 82.8116 92.1132 83.1732 91.3031C83.5405 90.4929 83.7241 89.4979 83.7241 88.3181Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.9023 101.035H123.002V73.9347H95.9023V101.035Z",
    fill: "url(#paint8_linear_26801_1590)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.42 101.035H144.831L153.52 92.346V73.9347H126.42V101.035Z",
    fill: "url(#paint9_linear_26801_1590)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.711 104.452H94.1939C93.2509 104.452 92.4851 103.686 92.4851 102.743V72.2265C92.4851 71.2831 93.2509 70.5177 94.1939 70.5177H124.711C125.654 70.5177 126.419 71.2831 126.419 72.2265V102.743C126.42 103.686 125.654 104.452 124.711 104.452Z",
    fill: "url(#paint10_linear_26801_1590)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.538 104.452H124.71C123.767 104.452 123.001 103.686 123.001 102.743V72.2265C123.001 71.2831 123.768 70.5177 124.71 70.5177H155.228C156.171 70.5177 156.937 71.2831 156.937 72.2265V93.054C156.937 93.5074 156.756 93.9417 156.436 94.2616L146.745 103.952C146.425 104.271 145.991 104.452 145.538 104.452Z",
    fill: "url(#paint11_linear_26801_1590)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M135.54 96.9665C134.988 96.9665 134.54 96.5188 134.54 95.9665V80.8068C134.54 80.2545 134.988 79.8068 135.54 79.8068H137.167C137.719 79.8068 138.167 80.2545 138.167 80.8068V87.2195C138.167 87.3042 138.236 87.3728 138.32 87.3728C138.366 87.3728 138.41 87.3521 138.439 87.3164L144.267 80.1746C144.457 79.9419 144.741 79.8068 145.042 79.8068H146.787C147.634 79.8068 148.097 80.793 147.557 81.4449L143.028 86.9114C142.744 87.2542 142.72 87.7435 142.971 88.1117L147.928 95.4043C148.379 96.0682 147.904 96.9665 147.101 96.9665H145.186C144.852 96.9665 144.539 96.7993 144.354 96.5209L140.701 91.0366C140.328 90.4772 139.521 90.4373 139.095 90.9573L138.393 91.8137C138.247 91.9924 138.167 92.2163 138.167 92.4473V95.9665C138.167 96.5188 137.719 96.9665 137.167 96.9665H135.54Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.385 162.068H92.486V134.969H65.385V162.068Z",
    fill: "url(#paint12_linear_26801_1590)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.1945 165.487H63.6774C62.7348 165.487 61.969 164.72 61.969 163.778V133.26C61.969 132.317 62.7348 131.552 63.6774 131.552H94.1959C95.1389 131.552 95.9044 132.318 95.9044 133.26V163.778C95.903 164.72 95.1389 165.487 94.1945 165.487Z",
    fill: "url(#paint13_linear_26801_1590)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M87.445 148.828C87.445 150.65 87.0862 152.2 86.3686 153.477C85.6566 154.755 84.6847 155.731 83.4529 156.405C82.2268 157.074 80.848 157.408 79.3167 157.408C77.7742 157.408 76.3898 157.071 75.1636 156.397C73.9375 155.723 72.9684 154.747 72.2564 153.469C71.5445 152.191 71.1885 150.645 71.1885 148.828C71.1885 147.007 71.5445 145.457 72.2564 144.18C72.9684 142.902 73.9375 141.929 75.1636 141.26C76.3898 140.586 77.7742 140.249 79.3167 140.249C80.848 140.249 82.2268 140.586 83.4529 141.26C84.6847 141.929 85.6566 142.902 86.3686 144.18C87.0862 145.457 87.445 147.007 87.445 148.828ZM83.7241 148.828C83.7241 147.649 83.5405 146.654 83.1732 145.843C82.8116 145.033 82.3002 144.419 81.6391 144C80.978 143.582 80.2039 143.372 79.3167 143.372C78.4296 143.372 77.6555 143.582 76.9944 144C76.3333 144.419 75.8191 145.033 75.4518 145.843C75.0902 146.654 74.9093 147.649 74.9093 148.828C74.9093 150.008 75.0902 151.003 75.4518 151.813C75.8191 152.624 76.3333 153.238 76.9944 153.657C77.6555 154.075 78.4296 154.285 79.3167 154.285C80.2039 154.285 80.978 154.075 81.6391 153.657C82.3002 153.238 82.8116 152.624 83.1732 151.813C83.5405 151.003 83.7241 150.008 83.7241 148.828Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.9023 162.069H123.002V148.139L108.277 154.419C107.637 154.693 106.893 154.548 106.398 154.056C105.906 153.562 105.761 152.819 106.035 152.177L113.375 134.97H95.9024L95.9023 162.069Z",
    fill: "url(#paint14_linear_26801_1590)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.6764 73.9347H33.159C32.2156 73.9347 31.4502 73.1692 31.4502 72.2266V41.7084C31.4502 40.7654 32.2156 40 33.159 40H63.6758C64.6191 40 65.3842 40.7654 65.3842 41.7084V72.2266C65.3853 73.1699 64.6204 73.9347 63.6764 73.9347Z",
    fill: "url(#paint15_linear_26801_1590)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.711 165.487H94.1939C93.2509 165.487 92.4851 164.721 92.4851 163.779V133.261C92.4851 132.318 93.2509 131.553 94.1939 131.553H115.96C116.399 131.553 116.816 131.722 117.128 132.016C117.192 131.955 117.258 131.9 117.33 131.853C117.612 131.659 117.944 131.558 118.274 131.554C118.699 131.563 119.18 131.729 119.505 132.054L125.919 138.467C126.587 139.135 126.587 140.218 125.919 140.885C125.251 141.552 124.169 141.553 123.502 140.885L117.238 134.62L110.845 149.61L124.041 143.983C124.566 143.755 125.173 143.812 125.652 144.128C126.13 144.445 126.418 144.981 126.418 145.554V163.779C126.42 164.72 125.654 165.487 124.711 165.487Z",
    fill: "url(#paint16_linear_26801_1590)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.1945 73.9347H63.6774C62.7348 73.9347 61.969 73.1692 61.969 72.2266V41.7084C61.969 40.7654 62.7348 40 63.6774 40H94.1959C95.1389 40 95.9044 40.7654 95.9044 41.7084V72.2266C95.903 73.1699 95.1389 73.9347 94.1945 73.9347Z",
    fill: "url(#paint17_linear_26801_1590)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2814 65.2878C40.8396 65.2878 40.4814 64.9297 40.4814 64.4878V48.9282C40.4814 48.4863 40.8396 48.1282 41.2814 48.1282H50.4878C50.9296 48.1282 51.2878 48.4863 51.2878 48.9282V50.3194C51.2878 50.7612 50.9296 51.1194 50.4878 51.1194H44.6721C44.2303 51.1194 43.8721 51.4776 43.8721 51.9194V54.4082C43.8721 54.85 44.2303 55.2082 44.6721 55.2082H49.9318C50.3737 55.2082 50.7318 55.5664 50.7318 56.0082V57.3994C50.7318 57.8413 50.3737 58.1994 49.9318 58.1994H44.6721C44.2303 58.1994 43.8721 58.5576 43.8721 58.9994V61.4966C43.8721 61.9385 44.2303 62.2966 44.6721 62.2966H50.5191C50.961 62.2966 51.3191 62.6548 51.3191 63.0966V64.4878C51.3191 64.9297 50.961 65.2878 50.5191 65.2878H41.2814Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.49 131.552H153.519V121.522L143.49 131.552Z",
    fill: "url(#paint18_linear_26801_1590)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.385 131.552H92.486V104.452H65.385V131.552Z",
    fill: "url(#paint19_linear_26801_1590)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8679 162.068H61.9676V134.969H34.8679V162.068Z",
    fill: "url(#paint20_linear_26801_1590)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.242 132.996H138.379C137.688 132.996 137.065 132.579 136.801 131.94C136.535 131.302 136.682 130.568 137.171 130.079L153.034 114.215C153.522 113.726 154.261 113.58 154.895 113.845C155.533 114.109 155.951 114.733 155.951 115.423V131.286C155.95 132.232 155.184 132.996 154.242 132.996Z",
    fill: "url(#paint21_linear_26801_1590)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.6764 165.487H33.159C32.2156 165.487 31.4502 164.72 31.4502 163.778V133.26C31.4502 132.317 32.2156 131.552 33.159 131.552H63.6758C64.6191 131.552 65.3842 132.318 65.3842 133.26V163.778C65.3853 164.72 64.6204 165.487 63.6764 165.487Z",
    fill: "url(#paint22_linear_26801_1590)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8733 140.027C49.7017 140.027 50.3733 140.699 50.3733 141.527V155.687C50.3733 156.515 49.7017 157.187 48.8733 157.187H48.2607C47.4323 157.187 46.7607 156.515 46.7607 155.687V141.527C46.7607 140.699 47.4323 140.027 48.2607 140.027H48.8733Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M71.536 48.1283C72.1918 48.1283 72.7715 48.5542 72.9675 49.18L76.6974 61.0908C76.7113 61.1353 76.7526 61.1656 76.7992 61.1656C76.8458 61.1656 76.887 61.1354 76.901 61.0909L80.6387 49.1792C80.8349 48.5538 81.4145 48.1283 82.0699 48.1283H82.8344C83.8616 48.1283 84.5849 49.1375 84.2548 50.1103L79.4499 64.27C79.2434 64.8786 78.6721 65.288 78.0294 65.288H75.5766C74.9342 65.288 74.3631 64.8789 74.1564 64.2706L69.3446 50.1109C69.014 49.138 69.7374 48.1283 70.7649 48.1283H71.536Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26801_1590)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_26801_1590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.17 147.446L104.195 153.438C103.769 153.58 103.363 153.174 103.505 152.748L109.497 134.773C109.765 133.971 110.215 133.241 110.813 132.643L164.368 79.0893C166.496 76.9611 169.946 76.9611 172.074 79.0893L177.854 84.869C179.982 86.9972 179.982 90.4473 177.854 92.5754L124.3 146.13C123.702 146.728 122.972 147.178 122.17 147.446Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M174 96.428L160.514 82.9421L154.996 88.4596L168.482 101.946L174 96.428Z",
    fill: "url(#paint23_linear_26801_1590)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.183 101.246L155.698 87.7603L110.868 132.59L124.354 146.076L169.183 101.246Z",
    fill: "url(#paint24_linear_26801_1590)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.226 144.587L103.506 152.748C103.364 153.174 103.769 153.58 104.195 153.438L112.357 150.717L106.226 144.587Z",
    fill: "url(#paint25_linear_26801_1590)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_26801_1590",
    x: 102.477,
    y: 75.4932,
    width: 76.9734,
    height: 77.9733,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.611765 0 0 0 0 0.905882 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26801_1590"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26801_1590",
    x1: 20.9502,
    y1: 36.7188,
    x2: 163.919,
    y2: 166.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26801_1590",
    x1: 133.917,
    y1: 104.452,
    x2: 133.917,
    y2: 119.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26801_1590",
    x1: 135.123,
    y1: 101.035,
    x2: 135.123,
    y2: 125.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26801_1590",
    x1: 78.9367,
    y1: 101.035,
    x2: 78.9367,
    y2: 134.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_26801_1590",
    x1: 48.4178,
    y1: 43.4169,
    x2: 48.4178,
    y2: 70.5179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_26801_1590",
    x1: 78.9355,
    y1: 43.4169,
    x2: 78.9355,
    y2: 70.5179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_26801_1590",
    x1: 78.9355,
    y1: 73.9347,
    x2: 78.9355,
    y2: 101.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_26801_1590",
    x1: 78.9367,
    y1: 70.5177,
    x2: 78.9367,
    y2: 104.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_26801_1590",
    x1: 109.452,
    y1: 73.9347,
    x2: 109.452,
    y2: 101.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_26801_1590",
    x1: 139.97,
    y1: 73.9347,
    x2: 139.97,
    y2: 101.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_26801_1590",
    x1: 109.452,
    y1: 70.5177,
    x2: 109.452,
    y2: 104.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_26801_1590",
    x1: 139.969,
    y1: 70.5177,
    x2: 139.969,
    y2: 104.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_26801_1590",
    x1: 78.9355,
    y1: 134.969,
    x2: 78.9355,
    y2: 162.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_26801_1590",
    x1: 78.9367,
    y1: 131.552,
    x2: 78.9367,
    y2: 165.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_26801_1590",
    x1: 109.452,
    y1: 134.97,
    x2: 109.452,
    y2: 162.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_26801_1590",
    x1: 48.4172,
    y1: 40,
    x2: 48.4172,
    y2: 73.9347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_26801_1590",
    x1: 109.453,
    y1: 131.553,
    x2: 109.453,
    y2: 165.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_26801_1590",
    x1: 78.9367,
    y1: 40,
    x2: 78.9367,
    y2: 73.9347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_26801_1590",
    x1: 148.504,
    y1: 121.522,
    x2: 148.504,
    y2: 131.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_26801_1590",
    x1: 78.9355,
    y1: 104.452,
    x2: 78.9355,
    y2: 131.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_26801_1590",
    x1: 48.4178,
    y1: 134.969,
    x2: 48.4178,
    y2: 162.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_26801_1590",
    x1: 146.311,
    y1: 113.714,
    x2: 146.311,
    y2: 132.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_26801_1590",
    x1: 48.4172,
    y1: 131.552,
    x2: 48.4172,
    y2: 165.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_26801_1590",
    x1: 160.083,
    y1: 83.3732,
    x2: 155.262,
    y2: 96.1152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_26801_1590",
    x1: 157.173,
    y1: 89.2353,
    x2: 174.169,
    y2: 114.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_26801_1590",
    x1: 103.477,
    y1: 145.281,
    x2: 111.94,
    y2: 152.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26801_1590"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75.9732,
    height: 75.9732,
    fill: "white",
    transform: "translate(103.477 77.4933)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossword);
export default __webpack_public_path__ + "static/media/Crossword.a569925116eee8d7ec9e54cc12f4b9b1.svg";
export { ForwardRef as ReactComponent };